import { teamMemberService } from "../../../../../Api/Services/TeamMembers";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import {
  IDailyDairyReportParams,
  IDailyDairyReportServiceResponse,
} from "../../types";

export const fetchTeamMembersDailyDairyReport = createServiceAsyncThunk<
  IDailyDairyReportServiceResponse,
  IDailyDairyReportParams
>(
  ACTION_NAMES.FETCH_TEAM_MEMBERS_DAILY_DAIRY_REPORT,
  (params) => teamMemberService.dailyDairyReport(params),
  ERROR_MESSAGES.TEAM_MEMBERS_DAILY_DAIRY_REPORT_FETCH_FAILURE
);

export const teamMembersDailyDairyReportSlice = createGenericSlice<
  IDailyDairyReportServiceResponse,
  IDailyDairyReportParams
>(
  SLICE_NAMES.TEAM_MEMBERS_DAILY_DAIRY_REPORT,
  fetchTeamMembersDailyDairyReport
);

export const {
  clearError: clearTeamMembersDailyDairyReportError,
  clearSuccessMessage: clearTeamMembersDailyDairyReportSuccess,
} = teamMembersDailyDairyReportSlice.actions;

export default teamMembersDailyDairyReportSlice.reducer;
